import { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import Home from '../pages/Home';
import Wrapper from '../components/wrapper/Wrapper';
import NotFound from '../components/notFound/NotFound';

const Treatment = lazy(() => import('../pages/Treatments'));
const TreatmentDetails = lazy(() => import('../components/treatment/TreatmentDetails'));
const AboutDetail = lazy(() => import('../components/about/AboutDetail'));
const Contact = lazy(() => import('../components/contact/Contact'));
const PrivacyPolicy = lazy(() => import('../pages/PrivacyPolicy'));
const Blogs = lazy(() => import('../components/blogs/Blogs'));
const BlogDetails = lazy(() => import('../components/blogs/BlogDetail'));

const AppRoutes = () => (
    <Routes>
      <Route element={<Wrapper />}>
        <Route index element={<Home />} />
        <Route path="/behandlingar" element={<Treatment />} />
        <Route path="/behandlingar/:id" element={<TreatmentDetails />} />
        <Route path="/behandlingar/*" element={<TreatmentDetails />} />
        <Route path="/kontakt" element={<Contact />} />
        <Route path="/om-oss" element={<AboutDetail />} />
        <Route path="/blogg" element={<Blogs />} />
        <Route path="/blogg/:id" element={<BlogDetails />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
);
export default AppRoutes;
